import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useAppDispatch } from "./store/hooks";
import { fetchLocations } from "./store/slices/locationsSlice";
import "./styles/App.css";
import InvitationAcceptance from "./components/InvitationAcceptance";
import { Dashboard } from "./components/Dashboard";
import {
  fetchConnections,
  fetchListingLocations,
  fetchListings,
} from "./store/slices/listingsSlice";
import { ListingDetailPage } from "./pages/ListingDetailPage";
import { fetchItemTypes, fetchTabLayouts } from "./store/slices/uiSlice";
import axios from "axios";
import { TabLayout } from "./components/Tabs/TabLayout";

const AppContent: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [customDomainMemberListingId, setCustomDomainMemberListingId] =
    useState<string | null>(null);
  const [isCheckingDomain, setIsCheckingDomain] = useState(true);

  useEffect(() => {
    // Dispatch all async actions to load data - run only once per app session
    dispatch(fetchLocations());
    dispatch(fetchListings());
    dispatch(fetchConnections());
    dispatch(fetchListingLocations());
    dispatch(fetchTabLayouts());
    dispatch(fetchItemTypes());

    // Check for custom domain mapping
    const checkDomainMapping = async () => {
      try {
        const response = await axios.get("/api/domain-info");
        if (response.data.hasMappedDomain && response.data.memberListingId) {
          console.log(
            `Custom domain detected: ${response.data.domain} -> ${response.data.memberListingId}`
          );
          setCustomDomainMemberListingId(response.data.memberListingId);
        }
      } catch (error) {
        console.error("Failed to check domain mapping:", error);
      } finally {
        setIsCheckingDomain(false);
      }
    };

    checkDomainMapping();
  }, []);

  if (isCheckingDomain) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          fontSize: "1.2rem",
          color: "#666",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          customDomainMemberListingId ? (
            <ListingDetailPage listingId={customDomainMemberListingId} />
          ) : (
            <Dashboard />
          )
        }
      />
      <Route path="/invite/:token" element={<InvitationAcceptance />} />
      <Route path="/persons/:id" element={<ListingDetailPage />} />
      <Route path="/events/:id" element={<ListingDetailPage />} />
      <Route path="/projects/:id" element={<ListingDetailPage />} />
      <Route path="/products/:id" element={<ListingDetailPage />} />
      <Route path="/services/:id" element={<ListingDetailPage />} />
    </Routes>
  );
};

const App: React.FC = () => {
  const tabsTest = {
    tab1: {
      label: "Tab 1",
      icon: "icon-tab-1",
      content: <div>Content for Tab 1</div>,
    },
    tab2: {
      label: "Tab 2",
      icon: "icon-tab-2",
      content: <div>Content for Tab 2</div>,
    },
    tab3: {
      label: "Tab 3",
      icon: "icon-tab-3",
      content: <div>Content for Tab 3</div>,
    },
  };

  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
